var SENTRY_RELEASE;SENTRY_RELEASE={name: "FarmHQ", version: "4.1.0"};